<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },

    variant: {
      type: String,
      default: 'body-1',
    },
  },

  computed: {
    styleClass() {
      let result = '';
      switch (this.variant) {
        case 'headline-1':
          result +=
            'tw-font-poppins tw-font-semibold tw-text-headline-1 leading-headline-1';
          break;
        case 'headline-2':
          result +=
            'tw-font-poppins tw-font-semibold tw-text-headline-2 leading-headline-2';
          break;
        case 'headline-3':
          result +=
            'tw-font-poppins tw-font-semibold tw-text-headline-3 leading-headline-3';
          break;
        case 'headline-4':
          result +=
            'tw-font-poppins tw-font-semibold tw-text-headline-4 leading-headline-4';
          break;
        case 'headline-5':
          result += 'tw-font-poppins tw-font-semibold tw-text-2xl leading-9';
          break;
        case 'headline-6':
          result += 'tw-font-poppins tw-font-semibold tw-text-xl leading-7';
          break;
        case 'headline-7':
          result += 'tw-font-poppins tw-font-semibold tw-text-base leading-6';
          break;
        case 'subtitle-1':
          result += 'tw-font-inter tw-font-bold tw-text-base leading-6';
          break;
        case 'subtitle-2':
          result += 'tw-font-inter tw-font-bold tw-text-sm leading-5';
          break;
        case 'body-1':
          result += 'tw-font-inter tw-text-base leading-6';
          break;
        case 'body-2':
          result += 'tw-font-inter tw-text-sm leading-5';
          break;
        case 'caption':
          result += 'tw-font-inter tw-text-xs leading-4';
          break;
        case 'button-1':
          result += 'tw-font-poppins tw-text-base leading-6 tw-font-semibold';
          break;
        case 'button-2':
          result += 'tw-font-poppins tw-text-sm leading-5 tw-font-semibold';
          break;
        default:
          result += 'tw-font-inter tw-text-base leading-6';
          break;
      }
      return result;
    },
  },
};
</script>
<template>
  <component :is="tag" :class="[styleClass]" @click="$emit('click')"
    ><slot
  /></component>
</template>
